import React, { FunctionComponent } from 'react'
import styles from './LoadingSpinner.module.css'

type Props = {
  testId?: string
}

const LoadingSpinner: FunctionComponent<Props> = ({ testId }) => (
  <div className={styles.LoadSpinnerWrapper} data-testid={testId}>
    <div className={styles.LoadSpinner} />
  </div>
)

export default LoadingSpinner
